import WithdrawalRequestSent from "../../../../modules/Account/components/WithdrawalRequestSent/WithdrawalRequestSent";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import { useCallback } from "react";
import { closeMobileSliderPageAction, openMobileSliderPageAction } from "../../../mobileAppActions";
import { useDispatch } from "react-redux";
import { MOBILE_SLIDER_PAGES_IDS } from "../mobileSliderPagesConstants";

function SlideMobileWithdrawalRequestSent() {
    const dispatch = useDispatch();

    const handleContinueTradingClick = useCallback(() => {
        dispatch(closeMobileSliderPageAction())
    }, [dispatch]);

    const onHistoryClick = useCallback(() => {
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.HISTORY));
    }, [dispatch]);

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader/>
        <WithdrawalRequestSent
            onContinueTradingClick={handleContinueTradingClick}
            onHistoryClick={onHistoryClick}
            className={'px-3'}
        />
    </MobileSliderPagesWrapper>
}

export default SlideMobileWithdrawalRequestSent;
